module.exports = __webpack_public_path__ + "img/visa.135ff99f.svg";